import { render, staticRenderFns } from "./ProgressBarSecondary.vue?vue&type=template&id=4a2e16fc&scoped=true&"
import script from "./ProgressBarSecondary.vue?vue&type=script&lang=js&"
export * from "./ProgressBarSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2e16fc",
  null
  
)

export default component.exports